// Types sourced from the generated OpenAPI schema (../api.gen.d.ts).
// Regenerate with scripts/generate-www-api-types.sh after backend changes.
import type { components, operations } from '../api.gen';

// Sentinel markers the backend wraps around matched terms in `snippet`
// (hawk.core.search.types HIGHLIGHT_START/END). We render the enclosed runs as
// <mark> React text nodes rather than injecting HTML, so document text stays
// escaped (no XSS). Keep in sync with the backend constants.
export const HIGHLIGHT_START = '\uE000';
export const HIGHLIGHT_END = '\uE001';

// Full-text sort options. `rank` (default) orders the most recent candidates
// by relevance; `recency` orders them newest-first.
type SearchQuery = NonNullable<
  operations['search_search_get']['parameters']['query']
>;
export type SearchSort = NonNullable<SearchQuery['sort']>;
export const DEFAULT_SORT: SearchSort = 'rank';

export type SearchMode = NonNullable<SearchQuery['mode']>;
export const DEFAULT_MODE: SearchMode = 'fts';

export type EntityType = components['schemas']['SearchHit']['entity_type'];
export type ContentKind = components['schemas']['SearchHit']['content_kind'];

// The API calls a hit `SearchHit`; the UI has always called it SearchResult.
export type SearchResult = components['schemas']['SearchHit'];

// `incomplete_tables` names public tables (e.g. 'event', 'message_pool');
// empty when complete.
export type IndexStatus = components['schemas']['IndexStatus'];

// `estimated_matches` is the planner's row estimate across the search pools;
// it can be off by a lot, so present it as approximate.
export type TooBroad = components['schemas']['TooBroad'];

// Scan pages may be empty and still carry `next_cursor`; `searched_through`
// is then the creation time of the oldest visible record checked.
// `index_status` is null when the database could not say in time; `too_broad`
// is set when an unscoped full-text query was too broad to rank, and `items`
// then holds its newest matches, possibly none. The optional fields are absent
// on older APIs.
export type SearchResponse = components['schemas']['SearchResponse'];

// How the page was searched: `scan` covers literal search and full-text
// searches the index could not finish.
export type SearchMethod = NonNullable<SearchResponse['method']>;
